var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-main"},[_vm._v(" 暂时不用这个页面 ")])}
var staticRenderFns = []

export { render, staticRenderFns }